import _ from "lodash";
import store from "CommonState/store";
import React, {
  Component,
} from "react";
import {
  Button,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import apifetch from "CommonCore/apifetch";
import {
  withLocation,
} from "CommonCore/router-util";
import AntragAnnehmenPopup from "App/antrag-annehmen-popup";
import {
  formatMassnahme,
} from "Apis/massnahme-api";
import antragApi from "Apis/antrag-api";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
} from "App/constants";
import {
  Panel,
} from "CommonComponents/bricks";

@store("k_einrichtungLookup", "k_antragstypLookup", "k_vertragsartLookup")
export class MassnahmeItem extends Component {
  // Maßnahme für die Anzeige formatieren
  render() {
    const text = formatMassnahme(this.props.massnahme, this.props);
    return <ListGroupItem>{text} </ListGroupItem>;
  }
}

@withLocation
export class BeantragenButton extends React.Component {
  render() {
    const { name } = this.props;
    return <Button variant='outline-primary' onClick={this.navigate}> {name} </Button>;
  }
  navigate = () => {
    const { history, to } = this.props;
    history.push(to);
  };
}

@withLocation
@antragApi.actions
export default class DashboardWidgetMassnahmen extends Component {
  constructor() {
    super();
    this.state = { modeAnnehmen: false };
  }

  load = async() => {
    const data = await apifetch("/api/shkantrag/massnahmevorgesehen");
    this.setState({ massnahmen: data.data });
  };

  componentDidMount() {
    // Via Service ermitteln, welche Angaben zur Person bereits erfasst sind
    this.load();
  }

  render() {
    const { massnahmen: data, modeAnnehmen } = this.state;
    const { AntragstellerModus } = this.props;

    const modus = ANTRAGSTELLERMODUS[AntragstellerModus];

    const massnahmen = modus.filterMassnahmen(data);

    return <Panel>

      {modeAnnehmen && <AntragAnnehmenPopup AntragstellerModus={AntragstellerModus} massnahmen={massnahmen} onClose={this.endAnnehmen} onAngenommen={this.onAngenommen} />}

      <h3>{modus.labelAntragstellung} </h3>
      Hier finden Sie die {AntragstellerModus == ASTMODUSKEY.WerkPrivat ? "Werkverträge" : AntragstellerModus == ASTMODUSKEY.Vortrag ? "Anträge" : "Stellen"}, die aktuell für Sie relevant sind
      <br />
      {_.isEmpty(massnahmen)
? <span><br />(aktuell keine vorhanden)</span>
: <span><br />
  <ListGroup> {_.map(massnahmen, item => <MassnahmeItem key={item.m_id} massnahme={item} />)}</ListGroup>
  <Button variant='primary' onClick={this.startAnnehmen}> {modus.labelButtonAntragStellen || "Antrag stellen"} </Button>
</span>
      }

    </Panel>;
  }

  endAnnehmen = () => {
    this.setState({ modeAnnehmen: false });
    this.load();
  };
  startAnnehmen = () => {
    this.setState({ modeAnnehmen: true });
  };

  onAngenommen = a_id => {
    this.setState({ modeAnnehmen: false }, () => {
      this.props.clearAntragList();
      this.props.history.push(`/antrag/${ a_id }`);
    });
  };
}

